module.exports = __webpack_public_path__ + "images/59f55efd2a4cfc579137275a61400431-bg.jpg";